module.exports = __webpack_public_path__ + "static/media/skola_osnova.63905ee0.png";